import CustomerProfile from "./components/CustomerProfile";

export default CustomerProfile;
